/**
 * Created by Ning Jiang on 11/24/2016.
 */
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";

export class WildNudgeSoundConfig implements ISoundConfig {

    public static instance:WildNudgeSoundConfig = new WildNudgeSoundConfig();
    AS_WIN:string="asWin";
    AS_WIN_BIG:string="asWinBig";
    MAIN_GAME_AMBIANCE:string = "background-music-main";
    FREE_SPIN_AMBIANCE:string = "background-music-fs";

    FREE_SPIN_INTRO:string = "fsIntro";
    FREE_SPIN_OUTRO:string = "fsOutro";

    ATTENTION_EFFECT:string = "anticipation";
    ATTENTION_EFFECT_FAIL:string = "anticipationFail";

    SCATTER_LANDING_1:string = "scatter1";
    SCATTER_LANDING_2:string = "scatter2";
    SCATTER_LANDING_3:string = "scatter3";
    FS_HEART_BEAT:string = "fsHeartBeat";

    RANDOM_FEATURE_LANDING:string = "randomLanding";
    RANDOM_FEATURE_NUDGE:string = "randomNudge";
    WILD_LANDING:string = "wildLanding";
    WILD_NUDGE:string = "wildNudge";

    SCATTER_NUDGE:string = "scatterNudge";

    REELS_SPINNING:string = "wheels-spinning";
    REELS_DEFAULT_BOUNCE:string[] = ["reel-one-landing", "reel-two-landing", "reel-three-landing", "reel-four-landing", "reel-five-landing"];

    FLY_BY_FIRE:string = "flyByFire";

    COUNT_UP:string = "countup";
    COUNT_UP_ENDS:string = "countupEnds";

    MULTIPLIER:string = "multiplier";

    WIN_TINY:string = "winTiny";
    WIN_SMALL:string = "winSmall";
    WIN_MEDIUM:string = "winMedium";
    WIN_LARGE:string = "winLarge";

    BIG_WIN:string = "bigWin";
    BIG_WIN_START:string = "bigWinStart";
    BIG_WIN_END_0:string = "bigWinEnds1";
    BIG_WIN_END_1:string = "bigWinEnds2";
    BIG_WIN_END_2:string = "bigWinEnds3";


    constructor() {
        if(WildNudgeSoundConfig.instance) {
            throw new Error("WildNudgeSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }

    public static getWinSoundByRatio(type:WinRatioType):string {
        switch(type) {
            case WinRatioType.TINY:
                return WildNudgeSoundConfig.instance.WIN_TINY;
            case WinRatioType.SMALL:
                return WildNudgeSoundConfig.instance.WIN_SMALL;
            case WinRatioType.MEDIUM:
                return WildNudgeSoundConfig.instance.WIN_MEDIUM;
            case WinRatioType.LARGE:
                return WildNudgeSoundConfig.instance.WIN_LARGE;
            default:
                throw new Error(`WildNudgeSoundConfig.getWinSoundByRatio(): ${type} sound is not added!`);
        }
    }
}